<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-券发放-修改
    -->
  <el-dialog
      title="修改券发放"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
  >

    <div class="product-add pb50">

      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
        <!-- 新增字段开始 -->
        <el-form-item label="券名称" prop="voucher_id">
          <el-select 
            v-model="form.voucher_id" 
            placeholder="请选择券"
            style="width: 100%;"
            clearable
            filterable
            @change="onVoucherChange"
            :disabled="true"
          >
            <el-option
              v-for="dept in voucherList"
              :key="dept.voucher_id"
              :label="dept.name"
              :value="dept.voucher_id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="扣除组织" prop="deduct_organization_name">
          <el-input 
            v-model="form.deduct_organization_name" 
            placeholder="选择券后自动填充" 
            class="max-w460"
            readonly
            :disabled="true"
          >
          </el-input>
        </el-form-item>
        
        <el-form-item label="单价" prop="unit_price_display">
          <el-input 
            v-model="form.unit_price_display" 
            placeholder="选择券后自动填充" 
            class="max-w460"
            readonly
            :disabled="true"
          >
          </el-input>
        </el-form-item>
        
        <el-form-item label="面额" prop="denomination">
          <el-input 
            v-model="form.denomination" 
            placeholder="选择券后自动填充" 
            class="max-w460"
            readonly
            :disabled="true"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        
        <el-form-item label="剩余数量" prop="remaining_num">
          <el-input 
            v-model="form.remaining_num" 
            placeholder="选择券后自动填充" 
            class="max-w460"
            readonly
            :disabled="true"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="操作数量" prop="num">
          <el-input-number 
            v-model="form.num" 
            placeholder="请输入操作数量" 
            class="max-w460"
            :min="0" 
            :max="form.max_num || 99999"
            controls-position="right"
            style="width: 100%;"
            @change="checkNumRange"
          ></el-input-number>
          <div class="el-form-item__tips" v-if="form.remaining_num">
            最大可操作数量: {{ form.remaining_num }}
          </div>
        </el-form-item>
        
        <el-form-item label="接收组织" prop="ma_organization_id">
          <el-select 
            v-model="form.ma_organization_id" 
            placeholder="请选择接收组织"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="dept in maOrganizationId"
              :key="dept.ma_organization_id"
              :label="dept.name"
              :value="dept.ma_organization_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number 
            v-model="form.sort" 
            placeholder="请输入排序" 
            class="max-w460"
            :min="0"
            :max="999"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import Voucher_distributeApi from '@/api/voucher_distribute.js';
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    draggable,
    Uediter
  },
  data() {
    return {
      maOrganizationId: [],
      voucherList: [],
      selectedVoucher: null,
      isupload: false,
      isImg: false,
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      form: {
        voucher_id: '',
        name: '',
        deduct_organization_name: '',
        unit_price_display: '',
        denomination: '',
        remaining_num: '',
        num: 1,
        ma_organization_id: '',
        sort: 50,
        max_num: 0,
        deduct_ma_organization_id: '',
        unit_price: '',
        unit_price_unit: '',
        image: [],
        intro: "",
        bannar: []
      },
      loading: false,
      rules: {
        name: [{ required: true, message: '请输入券发放名称', trigger: 'blur' }],
        voucher_id: [{ required: true, message: '请选择券', trigger: 'change' }],
        num: [
          { required: true, message: '请输入操作数量', trigger: 'blur' },
          { type: 'number', min: 1, message: '操作数量至少为0', trigger: 'blur' },  // 修正：min改为1
          { 
            validator: (rule, value, callback) => {  // 新增：自定义校验最大值
              if (value > this.form.max_num && this.form.max_num > 0) {
                callback(new Error(`操作数量不能超过${this.form.max_num}`));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ],
        ma_organization_id: [{ required: true, message: '请选择接收组织', trigger: 'change' }],
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.loadVoucher();
    this.loadOrganization();
    this.getDetail();
  },
  props: ["open_add", "voucher_distribute_id"],
  watch: {
    'form.remaining_num': function(newVal) {
      if (newVal) {
        this.form.max_num = parseInt(newVal);
        // 新增：同步操作数量的最大值限制
        this.$nextTick(() => {
          if (this.form.num > this.form.max_num) {
            this.form.num = this.form.max_num;
          }
        });
      }
    },
    'form.num': function(newVal) {
      if (newVal > this.form.max_num && this.form.max_num > 0) {
        this.$nextTick(() => {
          this.form.num = this.form.max_num;
        });
      }
    }
  },
  methods: {
    async loadOrganization() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_organization',
          action: 'getList',
        });
        
        if (!response) {
          this.$message.warning('组织列表接口返回为空');
          this.maOrganizationId = [];
          return;
        }
        
        if (response.code === 1 && response.data.list.data) {
          this.maOrganizationId = response.data.list.data || [];
        } else {
          this.$message.warning('获取组织列表失败：' + (response.msg || '未知错误'));
          this.maOrganizationId = [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.$message.error('加载组织列表失败，请稍后重试');
        this.maOrganizationId = [];
      }
    },
    
    async loadVoucher() {
      try {
        const response = await AfuncApi.call({
          model: 'voucher',
          action: 'getList',
          page: 1,
          list_rows: 1000
        });
        
        if (!response) {
          this.voucherList = [];
          return;
        }
        if (response.code === 1 && response.data.list) {
          this.voucherList = response.data.list.data || [];
        } else {
          this.voucherList = [];
        }
      } catch (error) {
        console.error('加载券列表失败:', error);
        this.voucherList = [];
      }
    },
    
    onVoucherChange(voucherId) {
      if (!voucherId) {
        this.clearVoucherInfo();
        return;
      }
      
      const voucher = this.voucherList.find(item => item.voucher_id === voucherId);
      if (voucher) {
        this.selectedVoucher = voucher;
        this.fillVoucherInfo(voucher);
      } else {
        this.clearVoucherInfo();
      }
    },
    
    fillVoucherInfo(voucher) {
      const unitMap = {
        0: '元/人次',
        1: '元/学时',
        2: '元/课时'
      };
      
      this.form.deduct_organization_name = voucher.organization_name || '未知组织';
      this.form.denomination = voucher.denomination || '0';
      this.form.remaining_num = voucher.sy_num || '0';
      
      const unitPrice = voucher.unit_price || '0';
      const unitPriceUnit = voucher.unit_price_unit || 0;
      this.form.unit_price_display = `${unitPrice} ${unitMap[unitPriceUnit] || unitMap[0]}`;
      
      this.form.deduct_ma_organization_id = voucher.ma_organization_id;
      this.form.unit_price = unitPrice;
      this.form.unit_price_unit = unitPriceUnit;
      
      this.form.max_num = parseInt(voucher.sy_num) || 0;
      
      if (this.form.num > this.form.max_num) {
        this.form.num = this.form.max_num;
      }
    },
    
    clearVoucherInfo() {
      this.selectedVoucher = null;
      this.form.deduct_organization_name = '';
      this.form.unit_price_display = '';
      this.form.denomination = '';
      this.form.remaining_num = '';
      this.form.deduct_ma_organization_id = '';
      this.form.unit_price = '';
      this.form.unit_price_unit = '';
      this.form.max_num = 0;
    },
    
    clearForm() {
      this.form = {
        voucher_id: '',
        name: '',
        deduct_organization_name: '',
        unit_price_display: '',
        denomination: '',
        remaining_num: '',
        num: 1,
        ma_organization_id: '',
        sort: 50,
        max_num: 0,
        deduct_ma_organization_id: '',
        unit_price: '',
        unit_price_unit: '',
        image: [],
        intro: "",
        bannar: []
      };
      this.selectedVoucher = null;
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    
    chooseCategory(){
      this.iscategorya = true;
    },
    
    openUpload(e) {
      this.isupload = true;
    },

    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    
    dialogFormVisible(result) {
      this.clearForm();
      this.$emit("close", {});
    },
    
    // 新增：校验操作数量范围
    checkNumRange(val) {
      if (val < 1) {
        this.form.num = 0;
        this.$message.warning('操作数量至少为0');
      } else if (val > this.form.max_num && this.form.max_num > 0) {
        this.form.num = this.form.max_num;
        this.$message.warning(`操作数量不能超过${this.form.max_num}`);
      }
    },
    
    async getDetail() {
      let self = this;
      try {
        self.loading = true; // 新增：加载状态
        const res = await Voucher_distributeApi.detail({voucher_distribute_id: self.voucher_distribute_id}, true);
        if (res.code === 1 && res.data) {
          // 修正：深度拷贝数据，确保响应式
          Object.keys(res.data).forEach(key => {
            if (self.form.hasOwnProperty(key)) {
              self.form[key] = res.data[key];
            }
          });
          
          self.ueditor.text = self.form.intro || '';
          self.isImg = !!self.form.image.length;
          
          if(!self.form.bannar){
            self.form.bannar = [];
          }
          if(!self.form.image){
            self.form.image = [];
          }
          
          // 修正：立即同步max_num，避免延迟
          if (self.form.remaining_num) {
            self.form.max_num = parseInt(self.form.remaining_num);
          }
          
          if (self.form.voucher_id) {
            const voucher = self.voucherList.find(item => item.voucher_id === self.form.voucher_id);
            if (voucher) {
              self.selectedVoucher = voucher;
              self.fillVoucherInfo(voucher);
            }
          }
        }
      } catch (error) {
        console.error('获取详情失败:', error);
        this.$message.error('获取详情失败，请稍后重试');
      } finally {
        self.loading = false;
      }
    },
    
    async onSubmit() {
      const self = this;
      
      // 第一步：表单验证
      try {
        await self.$refs.form.validate();
      } catch (error) {
        // 验证失败直接返回
        return;
      }
      
      // 第二步：业务规则验证
      if (self.form.num > self.form.max_num) {
        self.$message.error(`操作数量不能超过剩余数量(${self.form.max_num})`);
        return;
      }
      
      // 第三步：构造提交数据（修正：避免Object.assign的浅拷贝问题）
      const submitData = {
        voucher_distribute_id: self.voucher_distribute_id,
        voucher_id: self.form.voucher_id,
        name: self.form.name,
        num: self.form.num,          // 操作数量
        ma_organization_id: self.form.ma_organization_id,  // 接收组织ID
        sort: self.form.sort,
        deduct_ma_organization_id: self.form.deduct_ma_organization_id,
        unit_price: self.form.unit_price,
        unit_price_unit: self.form.unit_price_unit,
        image: self.form.image,
        intro: self.$refs.ue ? self.$refs.ue.getUEContent() : self.form.intro,
        bannar: self.form.bannar
      };
      
      // 第四步：提交数据
      self.loading = true;
      try {
        const data = await Voucher_distributeApi.edit(submitData, true);
        if (data.code === 1) {
          self.$message.success(data.msg || '修改成功');
          self.dialogFormVisible("success");
          self.$emit("refresh");
        } else {
          self.$message.error(data.msg || '提交失败');
        }
      } catch (error) {
        console.error('提交失败:', error);
        self.$message.error('提交失败，请稍后重试');
      } finally {
        self.loading = false;
      }
    },

    // 修正：只保留一个cancelFunc方法
    cancelFunc() {
      this.clearForm();
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      }else{
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误，请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
    },
  }
};
</script>

<style scoped>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.el-form-item__tips {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.max-w460 {
  max-width: 460px;
}

.pb50 {
  padding-bottom: 50px;
}

.common-button-wrapper {
  text-align: center;
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/voucher_distribute/index/part/edit.vue